import React from "react";

const TwoColumnsData = ({ data, className }) => {
    if (!data.items) return null;

    return (
        <div className={className}>
            {data.items.map((item, index) => {
                return (
                    <div
                        key={index}
                        className="flex justify-between items-center"
                    >
                        <div>{item.leftText}</div>
                        <div
                            className={
                                item.isRightTextProminent
                                    ? "text-lg text-skin-dark font-semibold"
                                    : ""
                            }
                        >
                            {item.rightText}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default TwoColumnsData;
